<div role="alert" aria-live="assertive" aria-atomic="false" aria-relevant="all" *ngIf="showNikeOverlay" [attr.aria-label]="overlayMessage" role="dialog" aria-modal="true">
	<div class="overlay d-flex justify-content-center align-items-center">
		<div>
			<img class="d-block pb-4" [src]="nikeLock" alt="Nike Connected Successful">
        	<img class="d-block" [src]="nikeDSGLogo">
		</div>
	</div>
</div>